"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.search.failed': '搜索数据库日志失败，请重试。',
};
